import { Stack, Step, StepContent, StepLabel, Stepper, Typography, Link as A, Button, Alert } from "@mui/material";
import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import { Link, useParams } from "react-router-dom";
import ActionRef from "./components/ActionRef";
import conf from "../../config/dpc.json";
import { BorderColor, YouTube } from "@mui/icons-material";
import { useState } from "react";
import Vimeo from '../Tools/Vimeo';
import Modal from '../Tools/Modal';
import Conflict from "./components/Conflict";
import Timeline from "./components/Timeline";
import useCart from "./utils/useCart";
import LearnyspeedAlert from "./components/LearnyspeedAlert";

export default function DpcTuto(){

    const { id, ref } = useParams()

    const { cart } = useCart()

    const [video, setVideo] = useState(false)

    const [help, setHelp] = useState(false)

    return (
        <Layout>
            
            <Stack spacing={2} sx={{maxWidth: 800, margin: 'auto', pb: 8}}>

                <Timeline />

                <Conflict />

                <LearnyspeedAlert />

                <Typography variant='h5'>
                    Finalisons maintenant votre {cart.dpcStep > 0 ? 'deuxième' : ''} inscription sur le site du DPC
                </Typography>

                <Alert severity='info'>
                    1h de crédit restant suffit pour une prise en charge DPC à 100%. <strong style={{ color: 'red' }}>N'oubliez pas de revenir sur ce formulaire pour valider votre inscription.</strong>
                </Alert>

                <Stepper orientation='vertical'>

                    <Step active={true}>

                        <StepLabel>
                            Copiez la référence de l'action DPC :
                        </StepLabel>

                        <StepContent>
                            <ActionRef value={ref} />
                        </StepContent>

                    </Step>
                    
                    <Step active={true}>

                        <StepLabel>
                            Connectez-vous sur votre <A href={conf.login} rel='noopener noreferrer' target='_blank'>compte DPC</A>
                        </StepLabel>

                    </Step>

                    <Step active={true}>

                        <StepLabel>
                            Cliquez sur le bouton <BorderColor sx={{width: 20, height: 20, mx: 0.5}} /> <b>Actions DPC</b> en haut, puis sur <A href={conf.actions} rel='noopener noreferrer' target='_blank'>Rechercher une action/S'inscrire</A> 🖱️
                        </StepLabel>

                    </Step>
                    
                    <Step active={true}>

                        <StepLabel>
                            Collez la référence de l'action à 11 chiffres puis cliquez sur <b>Recherche</b> 🔍 (ne renseignez pas d'autres critères)
                        </StepLabel>

                        <StepContent>
                            <ActionRef value={ref} />
                        </StepContent>

                    </Step>

                    <Step active={true}>

                        <StepLabel>
                            Cliquez sur le bouton <b>Détail</b> puis <b>Liste sessions</b>
                        </StepLabel>

                    </Step>

                    <Step active={true}>

                        <StepLabel>
                            Choisissez votre session en cliquant sur <b>S'inscrire</b> puis validez votre inscription ✔️
                        </StepLabel>

                    </Step>

                    <Step active={true}>

                        <StepLabel>
                            Vous avez terminé votre inscription sur le site du DPC ? Cliquez sur <b>Continuer</b>
                        </StepLabel>

                        <StepContent>

                            <Stack direction='row' justifyContent='space-between' flexWrap='wrap'>

                                {!video &&
                                    <Button
                                        startIcon={<YouTube />} 
                                        onClick={() => setVideo(true)}
                                        sx={{m: 1}}
                                    >
                                        Voir le tuto vidéo
                                    </Button>
                                }

                                <Stack direction='row' flexWrap='wrap'>

                                    <Button 
                                        onClick={() => setHelp(!help)}
                                        sx={{m: 1}}
                                        color='error'
                                        variant='outlined'
                                    >
                                        J'ai un problème
                                    </Button>

                                    <Button 
                                        variant='contained' 
                                        sx={{m: 1}}
                                        component={Link}
                                        to={`/courses/${id}/dpc/${ref}/fetch`}
                                    >
                                        Continuer
                                    </Button>

                                </Stack>

                            </Stack>

                        </StepContent>
                    </Step>

                </Stepper>

                {video &&
                    <Vimeo id={806262747} /> 
                }

                <Modal open={help} title="Besoin d'aide ?" onClose={() => setHelp(false)}>
                    <Typography>
                        Contactez Montaine au <A href='tel:+33554547771'>05 54 54 77 71</A> ou à <A href='mailto:sav@learnylib.com'>sav@learnylib.com</A>
                    </Typography>
                </Modal>
                
            </Stack>

            <Chat />

        </Layout>
    );
}